import { connect } from "react-redux";
import UserConfigListing from "./configListing";
import { bindActionCreators } from "redux";
import {userConfigListing, userconfigurationStatus} from "../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    helpdeskListDetails : state.UserHelpdesk.helpdesklisting,
    userconfigstatusDetails: state.UserHelpdesk.userconfigstatus,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userConfigListing,
        userconfigurationStatus
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserConfigListing);